<template>
  <AwButton
    label="Recherche"
    icon="i-ph-magnifying-glass-bold"
    variant="outline"
    color="secondary"
    :class="{ isActive: showGlobalSearchModal }"
    @click="open('all')"
  >
    <template #trailing>
      <ShortcutGroup class="ms-auto" />
    </template>
  </AwButton>
</template>

<script setup lang="ts">
import { useGlobalSearch } from "~/components/global-search/composables/useGlobalSearch";
const { open, showGlobalSearchModal } = useGlobalSearch();
</script>

<style scoped lang="scss">
.NavSearch {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  color: var(--gray-2);
  background: var(--white);
  height: 31px;
  font-size: var(--size-14);
  font-weight: 500;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid var(--gray-6);
  box-shadow: var(--shadow-0);

  &:hover {
    border: 1px solid var(--gray-5);
  }

  &:focus,
  &.isActive {
    border: 1px solid var(--blue);
    outline: 2px solid var(--blue-light);
  }
}

.NavSearchIcon {
  height: 18px;
  width: 18px;
  color: var(--gray-3);
}
</style>
